import React from 'react';
import { buyerReviews } from '../data/buyerReviews';

/**
 * Pre-launch: shows the three lanes. As soon as real reviews are added to
 * data/buyerReviews.ts, it switches to the buyers' faces automatically.
 */
const lanes = [{
  id: 'L1',
  color: 'bg-mint'
}, {
  id: 'L2',
  color: 'bg-amber'
}, {
  id: 'L3',
  color: 'bg-coral'
}];
type RatingProofProps = {
  tone?: 'dark' | 'light';
};
export function RatingProof({
  tone = 'dark'
}: RatingProofProps) {
  const light = tone === 'light';
  const ring = light ? 'ring-glacier-soft' : 'ring-rink-deep';
  const faces = buyerReviews.slice(0, 4);
  const hasReviews = faces.length > 0;
  return <div className="flex items-center gap-3" data-id="element-370" data-mp="3uhv1whjfyy2d">
      <div className="flex -space-x-2" data-id="element-371" data-mp="3aima6y7isok">
        {hasReviews ? faces.map(review => <img key={review.name} src={review.photo} alt="" className={`h-9 w-9 rounded-full object-cover ring-2 ${ring}`} data-id="element-372" data-mp="203kbw5r41xv0" />) : lanes.map(lane => <span key={lane.id} className={`flex h-9 w-9 items-center justify-center rounded-full font-display text-[12px] font-bold text-rink-deep ring-2 ${ring} ${lane.color}`} data-id="element-373" data-mp="1edlhc6rdmbu6">
                {lane.id}
              </span>)}
      </div>
      <p className={`text-[13px] leading-snug ${light ? 'text-ink-soft' : 'text-white/75'}`} data-id="element-374" data-mp="10mqd57rtoiwx">
        {hasReviews ? <>
            <span className={`font-semibold ${light ? 'text-ink' : 'text-white'}`} data-id="element-375" data-mp="1sd4iugpomoxi">
              {faces.map(r => r.name.split(' ')[0]).join(', ')}
            </span>
            <br data-id="element-376" data-mp="1jbn5v77kn3d1" />
            and other coaches already use it
          </> : <>
            <span className={`font-semibold ${light ? 'text-ink' : 'text-white'}`} data-id="element-377" data-mp="cvuebqoy8ng6">
              Beginner, Developing and Advanced
            </span>
            <br data-id="element-378" data-mp="7uwyhkrew5hu" />
            on the same ice, at the same time
          </>}
      </p>
    </div>;
}